import { createRouter, Navigate } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'

// router の生成をここに一本化する。実アプリ(main.tsx)だけでなく、
// 擬似バックエンドで同じ画面を動かす開発用スタンドアロンアプリ(@mbfab/app-client-standalone)からも使うため、
// 「片方だけ設定が変わって挙動が食い違う」ことがないようにしている
export function createAppRouter() {
  return createRouter({
    routeTree,
    // 未知のパスはトップ（発注照合）へ戻す。既存の @mbfab/app-client と同じ挙動に揃える
    defaultNotFoundComponent: () => <Navigate to="/" />,
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }
}
